import {useRef} from 'react';

import {createStorage} from '/util/async-storage/create-storage';

export function useStorage(options: any) {
  return useRef(createStorage(options)).current;
}
